"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeApi3ReaderProxyV1Address = computeApi3ReaderProxyV1Address;
exports.computeCommunalApi3ReaderProxyV1Address = computeCommunalApi3ReaderProxyV1Address;
exports.unsafeComputeDappId = unsafeComputeDappId;
exports.computeDappSpecificApi3ReaderProxyV1Address = computeDappSpecificApi3ReaderProxyV1Address;
const ethers = __importStar(require("ethers"));
const addresses_json_1 = __importDefault(require("../deployments/addresses.json"));
const typechain_types_1 = require("../typechain-types");
function computeApi3ReaderProxyV1Address(chainId, dapiName, dappId, metadata) {
    const api3ReaderProxyV1FactoryAddress = addresses_json_1.default.Api3ReaderProxyV1Factory[chainId.toString()];
    if (!api3ReaderProxyV1FactoryAddress) {
        throw new Error(`Api3ReaderProxyV1Factory deployment not found for chain with ID ${chainId}`);
    }
    const api3ServerV1OevExtensionAddress = addresses_json_1.default.Api3ServerV1OevExtension[chainId.toString()];
    if (!api3ServerV1OevExtensionAddress) {
        throw new Error(`Api3ServerV1OevExtension deployment not found for chain with ID ${chainId}`);
    }
    const implementationAddress = ethers.getCreate2Address(api3ReaderProxyV1FactoryAddress, ethers.keccak256(metadata), ethers.solidityPackedKeccak256(['bytes', 'bytes'], [
        typechain_types_1.Api3ReaderProxyV1__factory.bytecode,
        ethers.AbiCoder.defaultAbiCoder().encode(['address', 'bytes32', 'uint256'], [api3ServerV1OevExtensionAddress, ethers.encodeBytes32String(dapiName), dappId]),
    ]));
    return ethers.getCreate2Address(api3ReaderProxyV1FactoryAddress, ethers.keccak256(metadata), ethers.solidityPackedKeccak256(['bytes', 'bytes'], [
        typechain_types_1.ERC1967Proxy__factory.bytecode,
        ethers.AbiCoder.defaultAbiCoder().encode(['address', 'bytes'], [implementationAddress, '0x']),
    ]));
}
function computeCommunalApi3ReaderProxyV1Address(chainId, dapiName) {
    return computeApi3ReaderProxyV1Address(chainId, dapiName, 1, '0x');
}
function unsafeComputeDappId(dappAlias, chainId) {
    return BigInt(ethers.solidityPackedKeccak256(['bytes32', 'uint256'], [ethers.solidityPackedKeccak256(['string'], [dappAlias]), chainId]));
}
function computeDappSpecificApi3ReaderProxyV1Address(dappAlias, chainId, dapiName) {
    return computeApi3ReaderProxyV1Address(chainId, dapiName, unsafeComputeDappId(dappAlias, chainId), '0x');
}
//# sourceMappingURL=proxy.js.map